module.exports = __webpack_public_path__ + "img/main-banner.5c1a0f6d.png";